import { graphql } from '@ordering/gql';

export const getMerchantBySlugQuery = graphql(`
  query GetMerchantViaStorefrontSlug($storefrontSlugs: StorefrontSlugsInput!) {
    getStorefrontBySlug(slugs: $storefrontSlugs) {
      details {
        merchant {
          id
          businessName
          code
        }
        timezone
      }
    }
  }
`);
